import {
  Box,
  Chip,
  Divider,
  Grid,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import { blue, green, grey, orange, purple, red } from '@mui/material/colors';
import * as React from 'react';
import * as Redux from 'react-redux';
import {
  GREEN_COLOR,
  ORANGE_COLOR,
  notaHoverColor,
} from '../../../../constants/ColorsConst';
import { dateformat, notaToPonderacionHelper } from '../../../../helpers';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const PlanesEvaluacionesNotas = ({
  type = 1,
  materias,
  planesEvaluacion,
  notasEvaluativas,
  actividadesExtras,
  idDefinitiva = false,
}) => {
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const templateStore = Redux.useSelector((state) => state.template);

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handlePlanesEvaluacion = (materia) => {
    const planes = [];

    planesEvaluacion.forEach((plan) => {
      if (plan.materia.id === materia.id) {
        planes.push(plan);
      }
    });

    planes.sort(function (a, b) {
      return (
        a.fechaBloque.bloquePedagogico.numero -
        b.fechaBloque.bloquePedagogico.numero
      );
    });

    return planes.map((plan, i) => {
      let totalPonderacion = 0;
      let TPInstrumento = 0;

      let recuperaciones = [];
      let remedial = null;

      if (actividadesExtras) {
        recuperaciones = actividadesExtras.filter(
          (el) =>
            el.actividadExtra.planEvaluacion.id === plan.id &&
            el.actividadExtra.tipo === 'RECUPERACION',
        );

        remedial = actividadesExtras.find(
          (el) =>
            el.actividadExtra.planEvaluacion.id === plan.id &&
            el.actividadExtra.tipo === 'REMEDIAL',
        );
      }

      plan.temas.forEach((tema) => {
        tema.evaluaciones.forEach((eva) => {
          eva.instrumentos.forEach((instrumento) => {
            TPInstrumento += parseFloat(instrumento.ponderacion);

            let notaEval = null;
            if (notasEvaluativas) {
              notaEval = notasEvaluativas.find(
                (el) => el.ptevaInstrumento.id === instrumento.id,
              );
            }

            let recuperacion = null;
            if (recuperaciones) {
              recuperacion = recuperaciones.find(
                (el) =>
                  el.actividadExtra.ptevaInstrumento?.id === instrumento.id &&
                  el.actividadExtra.tipo === 'RECUPERACION',
              );
            }

            if (recuperacion) {
              const pon = notaToPonderacionHelper(
                parseInt(recuperacion.nota),
                recuperacion.actividadExtra.ponderacion,
                entidadesStore.ajustes.ponderacion,
              ).toFixed(2);
              totalPonderacion += parseFloat(pon);
            } else {
              if (notaEval) {
                const pon = notaToPonderacionHelper(
                  parseInt(notaEval.nota),
                  instrumento.ponderacion,
                  entidadesStore.ajustes.ponderacion,
                ).toFixed(2);
                totalPonderacion += parseFloat(pon);
              }
            }
          });
        });
      });

      return (
        <Box
          sx={{
            border: '1px solid black',
            borderRadius: 2,
            p: 1,
            width:
              type === 2
                ? templateStore.settings.openSidebar
                  ? '35vw'
                  : '45vw'
                : '400px',
            transition: 'width 0.2s',
            mb: type === 1 ? 0 : 3,
            mr: 2,
          }}
        >
          <Grid container spacing={0}>
            <Grid item md={6} align="left">
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="left"
              >
                <Typography sx={{ fontWeight: 'bold', fontSize: 18 }}>
                  {plan.fechaBloque.bloquePedagogico.nombre}
                </Typography>
                <Chip
                  label={`Def.: ${
                    remedial ? remedial.nota : Math.round(totalPonderacion)
                  } Pts`}
                  size="small"
                  sx={{
                    backgroundColor: notaHoverColor(
                      remedial
                        ? parseInt(remedial.nota)
                        : Math.round(totalPonderacion),
                    ),
                    fontSize: '13pt',
                    fontWeight: 'bold',
                    color: 'white',
                  }}
                />
              </Stack>
            </Grid>
            <Grid item md={6} align="right">
              <Typography sx={{ fontWeight: 'bold', fontSize: 12 }}>
                Docente:
              </Typography>
              <Typography sx={{ fontWeight: 'bold', color: green[800] }}>
                {plan.docente.usuario.perfil.pnombre}{' '}
                {plan.docente.usuario.perfil.papellido}
              </Typography>
            </Grid>

            <Grid item md={12}>
              {remedial && cardActividadExtra(plan, remedial)}
            </Grid>

            <Grid item md={12}>
              {recuperaciones.map((actividad) => {
                return cardActividadExtra(plan, actividad);
              })}
            </Grid>
            <Grid item md={12}>
              <Stack direction="row" spacing={1} justifyContent="space-between">
                <Typography sx={{ fontWeight: 'bold' }}>
                  Fecha de inicio:
                </Typography>
                <Typography sx={{}}>
                  {dateformat(plan.fechaBloque.desde, { inverse: true })} hasta{' '}
                  {dateformat(plan.fechaBloque.hasta, { inverse: true })}
                </Typography>
              </Stack>
            </Grid>
            <Grid item md={12}>
              <Divider />
            </Grid>
            <Grid item md={12}>
              {plan.temas && plan.temas.length === 0
                ? null
                : handlerTemas(plan.temas)}
            </Grid>
            <Grid item md={12}>
              <Divider />
            </Grid>
            <Grid item md={12}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
              >
                <Typography variant="body1" color="initial" sx={{ mr: 2 }}>
                  {`${notaToPonderacionHelper(
                    totalPonderacion,
                    100,
                    entidadesStore.ajustes.ponderacion,
                  ).toFixed(0)}%/100%`}
                  <label style={{ fontSize: '16pt', marginLeft: '20px' }}>
                    {totalPonderacion.toFixed(2)}/
                  </label>
                  {TPInstrumento.toFixed(2)} Pts
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      );
    });
  };

  const cardActividadExtra = (plan, actividad) => {
    const isRemedial = actividad.actividadExtra.tipo === 'REMEDIAL';

    let actividadRemplazada = null;

    if (!isRemedial) {
      plan.temas.forEach((tema) => {
        tema.evaluaciones.forEach((eva) => {
          eva.instrumentos.forEach((instrumento) => {
            if (
              instrumento.id === actividad.actividadExtra.ptevaInstrumento.id
            ) {
              actividadRemplazada = instrumento;
            }
          });
        });
      });
    }

    return (
      <Box
        key={`activi-${actividad.i}`}
        sx={{
          backgroundColor: isRemedial ? purple[50] : blue[50],
          mb: 1,
          p: 1,
        }}
      >
        <Grid container spacing={0}>
          <Grid item md={12}>
            <Typography sx={{ fontWeight: 'bold', fontSize: 18, mb: 1 }}>
              {isRemedial ? 'ACTIVIDAD' : 'ACTIVIDAD DE'}{' '}
              {actividad.actividadExtra.tipo}
            </Typography>
          </Grid>
          <Grid item md={12}>
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold' }}
              color="initial"
            >
              Actividad evaluativa:{' '}
              {actividad.actividadExtra.instrumento.nombre}
            </Typography>
            {!isRemedial && (
              <Typography
                variant="body1"
                sx={{ fontWeight: 'bold' }}
                color="initial"
              >
                Actividad remplazada: {actividadRemplazada.instrumento.nombre}
              </Typography>
            )}
          </Grid>
          <Grid item md={12}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography
                variant="body1"
                sx={{ fontWeight: 'bold' }}
                color="initial"
              >
                Fecha de entrega:{' '}
                {dateformat(actividad.actividadExtra.fechaInicio, {
                  inverse: true,
                })}
              </Typography>

              <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
              >
                <Typography sx={{ fontWeight: 'bold' }} color="initial">
                  <label
                    style={{
                      color: actividad.nota
                        ? parseInt(actividad.nota) >= 16
                          ? green[800]
                          : parseInt(actividad.nota) >= 10
                          ? orange[800]
                          : red[600]
                        : null,
                      fontSize: '14pt',
                    }}
                  >
                    {actividad.nota
                      ? notaToPonderacionHelper(
                          parseInt(actividad.nota),
                          actividad.actividadExtra.ponderacion,
                          entidadesStore.ajustes.ponderacion,
                        ).toFixed(2)
                      : '--'}
                  </label>
                  {'/'}
                  {parseFloat(actividad.actividadExtra.ponderacion).toFixed(
                    2,
                  )}{' '}
                  Pts
                </Typography>
                <Typography
                  sx={{
                    ml: 1.4,
                    color: actividad.nota
                      ? parseInt(actividad.nota) >= 16
                        ? green[800]
                        : parseInt(actividad.nota) >= 10
                        ? orange[800]
                        : red[600]
                      : null,
                    fontWeight: '700',
                    fontSize: '14pt',
                  }}
                >
                  {actividad.nota ? actividad.nota : '--'}
                </Typography>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const handlerTemas = (temas) => {
    return temas.map((el, i) => {
      return (
        <Box key={`temas-${i}`}>
          <Grid container spacing={0}>
            <Grid item md={10}>
              <Typography
                sx={{ fontWeight: 'bold', fontSize: 14, color: ORANGE_COLOR }}
              >
                {el.tema.titulo}
              </Typography>
            </Grid>
            <Grid item md={12}>
              {el.evaluaciones && el.evaluaciones.length === 0
                ? null
                : handlerEvaluaciones(el.evaluaciones)}
            </Grid>
          </Grid>
        </Box>
      );
    });
  };

  const handlerEvaluaciones = (evaluaciones) => {
    return evaluaciones.map((eva, i) => {
      // const totalPonderacion = eva.instrumentos.reduce((total, instrumento) => {
      //   const nota = notasEvaluativas.find(
      //     (el) => el.ptevaInstrumento.id === instrumento.id,
      //   );

      //   return (
      //     total +
      //     notaToPonderacionHelper(
      //       nota ? parseInt(nota.nota) : 0,
      //       instrumento.ponderacion,
      //       entidadesStore.ajustes.ponderacion,
      //     )
      //   );
      // }, 0);

      return (
        <Grid key={`eva-${i}`} container spacing={0}>
          <Grid item md={8}>
            <Typography
              sx={{
                fontWeight: 'bold',
                color: GREEN_COLOR,
                ml: 2,
              }}
            >
              {eva.evaluacion.nombre}
            </Typography>
          </Grid>
          <Grid item md={4}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
            >
              <Typography
                fontSize="10pt"
                fontWeight="bold"
                textAlign="flex-end"
                sx={{ mr: '60px' }}
              >
                Porcentajes
              </Typography>
              <Typography
                fontSize="10pt"
                fontWeight="bold"
                textAlign="flex-end"
              >
                Puntos
              </Typography>
              <Typography
                fontWeight="bold"
                textAlign="flex-end"
                fontSize="10pt"
                sx={{ ml: 4 }}
              >
                Nota
              </Typography>
            </Stack>
          </Grid>
          <Grid item md={12}>
            {eva.instrumentos && eva.instrumentos.length === 0
              ? null
              : handlerActividades(eva.instrumentos)}
          </Grid>
        </Grid>
      );
    });
  };

  const handlerActividades = (instrumentos) => {
    return instrumentos.map((instrumento, i) => {
      let nota = null;
      if (notasEvaluativas) {
        nota = notasEvaluativas.find(
          (el) => el.ptevaInstrumento.id === instrumento.id,
        );
      }

      return (
        <Box
          key={`activi-${i}`}
          sx={{
            pl: 2,
            backgroundColor: grey[100],
            mb: 0.5,
          }}
        >
          <Grid container spacing={0}>
            <Grid item md={12}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 'bold' }}
                  color="initial"
                >
                  {dateformat(instrumento.fechaInicio, { inverse: true })}:{' '}
                  {instrumento.instrumento.nombre}
                </Typography>

                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="flex-end"
                >
                  <Typography
                    color="initial"
                    sx={{
                      fontSize: '14pt',
                      fontWeight: 'bold',
                      mr: '85px',
                    }}
                  >
                    {nota
                      ? `${notaToPonderacionHelper(
                          notaToPonderacionHelper(
                            parseInt(nota.nota),
                            instrumento.ponderacion,
                            entidadesStore.ajustes.ponderacion,
                          ),
                          100,
                          entidadesStore.ajustes.ponderacion,
                        ).toFixed(0)}%`
                      : '--'}
                  </Typography>
                  <Typography color="initial">
                    <label
                      style={{
                        color: notaHoverColor(
                          nota ? parseInt(nota.nota) : null,
                        ),
                        fontSize: '14pt',
                        fontWeight: 'bold',
                      }}
                    >
                      {nota
                        ? notaToPonderacionHelper(
                            parseInt(nota.nota),
                            instrumento.ponderacion,
                            entidadesStore.ajustes.ponderacion,
                          ).toFixed(2)
                        : '--'}
                    </label>
                    {'/'}
                    {parseFloat(instrumento.ponderacion).toFixed(2)}
                  </Typography>
                  <Typography
                    sx={{
                      ml: 4,
                      color: nota
                        ? parseInt(nota.nota) >= 16
                          ? green[800]
                          : parseInt(nota.nota) >= 10
                          ? orange[800]
                          : red[600]
                        : null,
                      fontWeight: 'bold',
                      fontSize: '10pt',
                    }}
                  >
                    {nota ? nota.nota : '--'}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      );
    });
  };

  const type1 = (
    <>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="perfil"
      >
        {materias.map((el, i) => {
          return (
            <Tab
              key={`tabs_${el.id}`}
              value={i}
              label={
                <React.Fragment>
                  {el.nombre}
                  <br />
                  {!idDefinitiva ? (
                    <span style={{ fontSize: 'smaller' }}>{el.def}</span>
                  ) : null}
                </React.Fragment>
              }
            />
          );
        })}
      </Tabs>
      {materias.map((el, y) => {
        return (
          <TabPanel key={`tab_panel_${el.id}`} value={value} index={y}>
            <Stack direction="row" sx={{ overflowY: 'auto' }}>
              {handlePlanesEvaluacion(el.id)}
            </Stack>
          </TabPanel>
        );
      })}
    </>
  );

  const type2 = (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
      }}
    >
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Materias"
        sx={{
          borderRight: 1,
          borderColor: 'divider',
          minWidth: '180px',
          width: '180px',
        }}
      >
        {materias.map((el, i) => {
          return (
            <Tab key={`tabs_${el.id}`} label={el.nombre} {...a11yProps(i)} />
          );
        })}
      </Tabs>
      {materias.map((el, y) => {
        return (
          <TabPanel key={`tab_panel_${el.id}`} value={value} index={y}>
            <Box
              sx={{
                mb: 2,
                display: 'flex',
                flexDirection: 'column',
                overflowX: 'auto',
              }}
            >
              {handlePlanesEvaluacion(el)}
            </Box>
          </TabPanel>
        );
      })}
    </Box>
  );

  return type === 1 ? type1 : type2;
};

export default PlanesEvaluacionesNotas;
